<div class="root" >
  <mat-toolbar class="toolbar" color="primary">
    <button mat-button aria-label="Main Menu" (click)="menuToggle()">
      <mat-icon >menu</mat-icon>
    </button>
    <span>Localiti</span>
  </mat-toolbar>
  <mat-sidenav-container >
    <mat-sidenav style="min-width: 200px;" #sidenav mode="side">
      <mat-nav-list>
        <a *ngIf="(auth.isGlobalAdmin|async)" [routerLink]="['ga', 'accounts']" class="menu-link"><mat-icon>account_circle</mat-icon> <div class="menu-link-text">(Admin) All Accounts</div></a>
        <a *ngIf="(auth.isClient | async) && !(auth.isRetailer | async)"  class="menu-link"><div class="menu-link-text">Account Not Activated Yet</div></a>
        <!-- <a *ngIf="(auth.isClient | async)" [routerLink]="['account', 'me']"  class="menu-link"><mat-icon>account_circle</mat-icon> <div class="menu-link-text">Account</div></a> -->
        
        <a *ngIf="(auth.isRetailer |async)" [routerLink]="['dashboard']" class="menu-link"><mat-icon>dashboard</mat-icon> <div class="menu-link-text">Dashboard</div></a>
        <mat-expansion-panel *ngIf="(auth.isRetailer | async)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <a [routerLink]="['retailers']" class="menu-expander-label"><mat-icon>place</mat-icon> Businesses</a>
            </mat-panel-title>
            <!-- <mat-panel-description>
              
            </mat-panel-description> -->
          </mat-expansion-panel-header>
          <a *ngFor="let r of retailers" mat-list-item [routerLink]="['/retailers', r.id]">{{ r.name }}</a>
        </mat-expansion-panel>
        <!-- <mat-expansion-panel *ngIf="(auth.user | async)" class="offers-expander" >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="menu-expander-label"><mat-icon>local_offer</mat-icon>Offers</div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-expansion-panel class="offers-subpanel" *ngFor="let loc of locations" (afterExpand)="offersExpanded(loc)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <a [routerLink]="['/locations', loc.id, 'offers']">{{loc.name}}</a>
                
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-progress-spinner class="inner" *ngIf="!loc.offers"
            mode="indeterminate"></mat-progress-spinner>
            <div *ngIf="loc.offers">
              <a *ngFor="let offer of loc.offers" class="offer-subpanel-link" mat-list-item [routerLink]="['/locations', loc.id, 'offers', offer.id]">{{ offer.display_name }}</a>
            </div>
            
            
            </mat-expansion-panel>
        </mat-expansion-panel> -->
        <a *ngIf="(auth.isLoggedIn | async)" (click)="logout()"  class="menu-link"><mat-icon>login</mat-icon> <div class="menu-link-text">Log Out</div></a>
        <a *ngIf="!(auth.isLoggedIn | async)" [routerLink]="['login']"  class="menu-link"><mat-icon>login</mat-icon> <div class="menu-link-text">Login</div></a>

        <!-- <a mat-list-item *ngIf="!(auth.user | async)" [routerLink]="'/login'" mat-list-item class="menu-item"><mat-icon [routerLink]="'/login'">login</mat-icon> Log In</a>
        <a *ngIf="(auth.user | async)" (click)="logout()" mat-list-item class="menu-item"><mat-icon>login</mat-icon> Log Out</a> -->
      </mat-nav-list>
    </mat-sidenav>
    
    <mat-sidenav-content>
      <div class="content-container">
        <router-outlet ></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>